import { Component, OnInit } from "@angular/core";
import { Payment } from "../models/payment";
import * as moment from "moment/moment";
import { environment } from "../../../../environments/environment";
import { Router } from "@angular/router";
import { ChargesStoreService } from "../services/charges-store.service";
import { LoaderService } from "../../../loader/loader.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ChargesService } from "../services/charges.service";
import { ChargeBodyPut } from "../models/charge-body-put";

@Component({
  selector: "app-reason-return",
  templateUrl: "./reason-return.component.html",
  styleUrls: ["./reason-return.component.scss"],
})
export class ReasonReturnComponent implements OnInit {
  env;
  page = 1;
  pageSize = 10;
  collectionSize = 0;
  payments: Payment[];
  paymentsSelected: Payment[] = [];
  paymentItemsSelected: number = 0;
  mot_reprovado: string;
  modalActive: NgbModalRef;

  private unsubscribe$ = new Subject();

  constructor(
    public router: Router,
    public chargesStore: ChargesStoreService,
    private modalService: NgbModal,
    private chargesService: ChargesService,
    private loaderService: LoaderService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.getReturnPayments();
  }

  openModal(modal) {
    if (this.paymentItemsSelected > 0) {
      this.modalActive = this.modalService.open(modal, { size: "lg" });
    }
  }
  onChangeSelectionPayment(payment: Payment) {
    if (payment.selected) {
      const selectedIndex = this.paymentsSelected.findIndex(selected => selected._id === payment._id);
      if (selectedIndex === -1) this.paymentsSelected.push(payment);
    } else {
      this.paymentsSelected = this.paymentsSelected.filter(selected => selected._id !== payment._id);
    }

    this.paymentItemsSelected = this.paymentsSelected.length;
  }

  async onSubmit(status) {
    let chargesBodyPut: ChargeBodyPut = {};

    const loader = await this.loaderService.notifica({
      title: "Processando operação...",
      date: moment().toISOString(),
      type: "loading",
    });

    chargesBodyPut.operador = this.env.user.codigo_externo;
    chargesBodyPut.ids = this.paymentsSelected.map(payment => payment._id);
    chargesBodyPut.motivo_devolucao = this.paymentsSelected.map(payment => payment.motivo_devolucao)[0];
    chargesBodyPut.cod_motivo_devolucao = this.paymentsSelected.map(payment => payment.cod_motivo_devolucao)[0];
    if (status.includes("rejeitado")) {
      chargesBodyPut.mot_reprovado = this.mot_reprovado;
    }

    const chargesMsgResult = await this.chargesService
      .updateCharges(this.env.selected.cnpj, "payments", status, chargesBodyPut)
      .toPromise();

    if (chargesMsgResult.ok) {
      this.paymentsSelected = [];
      this.paymentItemsSelected = this.paymentsSelected.length;
      this.mot_reprovado = null;
    }

    loader.dismiss();
    await this.onChangePagination();

    this.modalActive.close();
  }

  getReturnPayments() {
    this.chargesStore.returnPayments$.pipe(takeUntil(this.unsubscribe$)).subscribe(paymentResult => {
      this.pageSize = paymentResult.limit;
      this.page = paymentResult.page;

      this.collectionSize =
        paymentResult.total_docs !== undefined && paymentResult.total_docs !== null
          ? paymentResult.total_docs
          : paymentResult.result.length;
      this.payments = paymentResult.result;
    });
  }
  async onChangePagination() {
    const loader = await this.loaderService.notifica({
      title: "Atualizando paginação...",
      date: moment().toISOString(),
      type: "loading",
    });

    await this.chargesStore.getPayments(this.env.selected.cnpj, this.pageSize, this.page);

    loader.dismiss();
  }
}
